<template>
    <v-col cols="12">

        <v-btn class="mt-1" 
               :disabled="!hotel || (hotel && !hotel.bookable_via_iescape)"
               :href="onboardUrl" 
               title="Onboard property"><v-icon>list</v-icon></v-btn>
        <v-btn class="mt-1" 
               :disabled="!hotel || (hotel && !hotel.bookable_via_iescape)"
               :href="reservationsUrl" 
               title="Reservation management"
        ><v-icon>hotel</v-icon></v-btn>
        <v-btn class="mt-1" 
               :href="editUrl"
               title="Property details"><v-icon>edit</v-icon></v-btn>
        <v-btn class="mt-1" 
               :href="facilitiesUrl"
               title="Facility management"><v-icon>pool</v-icon></v-btn>
        <v-btn class="mt-1" 
               :href="imageLibraryUrl"
               title="Image library"><v-icon>insert_photo</v-icon></v-btn>
        <v-btn class="mt-1" 
               :disabled="!hotel ||(hotel && (hotel.is_tailormade_tour || !hotel.bookable_via_iescape))"
               :href="cloneRateDatesUrl"
               title="Clone rate dates"><v-icon>content_copy</v-icon></v-btn>
        <v-btn class="mt-1" 
               :disabled="!hotel || (hotel && !hotel.bookable_via_iescape)"
               :href="dailyPlannerUrl"
               title="Daily planner"><v-icon>edit_calendar</v-icon></v-btn>
        <v-btn class="mt-1" 
               :disabled="!hotel || (hotel && (hotel.is_tailormade_tour || !hotel.bookable_via_iescape))"
               :href="batchLoaderUrl" 
               title="Batch loader"><v-icon>file_upload</v-icon></v-btn>
        <v-btn class="mt-1" 
               :href="viewLiveUrl"
               title="Live overview page"><v-icon>web</v-icon></v-btn>
        <v-btn class="mt-1" 
               title="Additional fees"
               :disabled="!hotel || (hotel && !hotel.bookable_via_iescape)"
               :href="additionalFeesUrl"><v-icon>attach_money</v-icon></v-btn>
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to a hotels' pages
     */
    export default {
        props:['pageid', 'results'],

        data: function() {
            return {
                isTailormadeTour: null,
                tripsUrl: '',
                reservationsUrl: '',
                editUrl: '',
                cloneRateDatesUrl: '',
                batchLoaderUrl: '',
                dailyPlannerUrl: '',
                facilitiesUrl: '',
                imageLibraryUrl: '',
                additionalFeesUrl: '',
                onboardUrl: '',
                viewLiveUrl: '',
                hotel: null
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
            // Extract the hotel ID from the result set passed into this panel from the dashboard
            var hotelKey = this.results.data[0].hotel_key;

            this.isTailormadeTour = this.results.data[0].is_tailormade_tour == 1;

            this.reservationsUrl = "/hotels/" + hotelKey + "/reservation-administration";
            this.editUrl = "/hotels/" + hotelKey;
            this.cloneRateDatesUrl = "/hotels/" + hotelKey + "/clone-rate-dates";
            this.batchLoaderUrl = "/hotels/" + hotelKey + "/batch-loader";
            this.dailyPlannerUrl = "/hotels/" + hotelKey + "/daily-planner";
            this.facilitiesUrl = "/hotels/" + hotelKey + "/facility-management";
            this.imageLibraryUrl = "/hotels/" + hotelKey + "/photo-library";
            this.viewLiveUrl = "https://www.i-escape.com";
            this.additionalFeesUrl = "/hotels/" + hotelKey + "/additional-fees/list";
            this.onboardUrl = "hotels/" + hotelKey + "/onboard-hotel";

            this.loadHotel();
        },

        methods: {
            loadHotel: function(){
                // Extract the hotel ID from the result set passed into this panel from the dashboard
                var hotelKey = this.results.data[0].hotel_key;
                axios.get('/api/hotels/' + hotelKey)
                .then(function(response){
                    this.hotel = response.data;
                    this.viewLiveUrl = "https://www.i-escape.com/" + response.data.main_url_name.url_name;
                }.bind(this));
            }
        },
    }
</script>
